<template>
	<div>
		<el-form>
			<!-- 用于显示大型设备控制弹框 -->
			
			<el-form-item v-for="(item,index) in formList" :key="index" :label="item.cn_name" label-width="120px">

				<!-- 开关 -->
				<span v-if="item.cn_name=='开关机'" @click="showSwitchConfirm(item)" class="controlSwitch">
					<el-switch v-model="switchValue" disabled></el-switch>
				</span>		
				<!-- 非开关设置	 -->
				<el-input v-if="item.cn_name!='开关机'" style="width:120px" v-model="item.data_tag" type="number" auto-complete="off"></el-input>
		
				<el-button v-if="item.cn_name!='开关机'" type="primary" @click="controlFn(item)">确定</el-button>
				
								
			</el-form-item>			
			
		</el-form>
		<el-dialog title="确定弹框" :visible.sync="confirmFlag" width="500px" append-to-body>
			<div class="userInfo">
				<p>大型设备开关机对机房环境影响较大，请谨慎操作<br/>
					{{confirmHint}}</p>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="confirmFlag=false">取消</el-button>
				<el-button type="primary" @click="controlFn(switchItem,switchNum)">确定</el-button>
			</div>
		</el-dialog>
	</div>
	
</template>
<script>

export default {
  name: 'app',
  data(){
    return {
		mytts_device_id: this.tts_device_id || "",
		myDeviceData: this.deviceData || {},
		formList:[],
		// 开关操作参数
		switchValue: true,
		switchNum: 1,
		confirmFlag: false,
		confirmHint: "确定进行关机操作吗？",
		onValue: 1,
		offValue: 1,
		switchItem: {}

    }
  },
  watch:{
	
  },
  mounted(){
	this.$nextTick(function() {	
		this.getFormContent();
		this.formatSwitch();

	})  
  },
  props:['tts_device_id','deviceData'],
  methods: {
	formatSwitch(){
		// 处理开关数据
		if(this.myDeviceData.dataList && this.myDeviceData.dataList.switchState && this.myDeviceData.dataList.switchState.value=="运行"){
			this.switchValue = true;
		}else{
			this.switchValue = false;
		}
		
	},
	showSwitchConfirm(item){
		this.formatSwitch()
		this.confirmFlag = true;
		
		if(item.data_tag!=""){
			let switchObj = {}; 
			item.data_tag.split(',').map(item => item.split('=')).map(item => switchObj[item[1]] = Number(item[0]));
			this.onValue = switchObj['开']
			this.offValue = switchObj['关']
		}
		if(this.switchValue==true){
			this.confirmHint = "确定进行关机操作吗？";
			this.switchNum = this.offValue;
		}else{
			this.confirmHint = "确定进行开机操作吗？";
			this.switchNum = this.onValue;
		}
		this.switchItem = item;
		
	},
	//   获取弹框表单需显示内容
	getFormContent() {
		this.mytts_device_id = this.tts_device_id || "";
		let valiCodeParams={
			uid:this.getCookie('uid'),
			tts_device_id: this.mytts_device_id || "",
			token:this.getCookie('token'),
			time:Date.parse( new Date()),
			terminalId:4
		};
		this.sign2(valiCodeParams);
		this.$ajax.post(this.$store.state.domain2+"/admin/Ttsdevicectl/List",this.$qs.stringify(valiCodeParams),{
			emulateJSON: true
		}).then(res=>{
			if(res.data.code==200 & res.data.data!=null){	

				this.formList = res.data.data || [];

			}else if(res.data.code==10008){
				this.delCookie('username');
					this.$router.push('/login/');
					this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);  
			}else{
				//console.log(res.data.msg);
			}
		});
	},
	controlFn(item,valueParam){
		console.log(valueParam)
		let valiCodeParams={
			uid:this.getCookie('uid'),
			id: item.id,
			tts_device_id: this.mytts_device_id || "",
			product_id: item.product_id || "",
			data_value: "",
			token:this.getCookie('token'),
			time:Date.parse( new Date()),
			terminalId:4
		};
		if(valueParam || valueParam==0){
			valiCodeParams.data_value = valueParam
		}else{
			valiCodeParams.data_value = parseInt(item.data_tag);
		}
		this.sign2(valiCodeParams);
		this.$ajax.post(this.$store.state.domain2+"/admin/Ttsdevicectl/Change",this.$qs.stringify(valiCodeParams),{
			emulateJSON: true
		}).then(res=>{
			if(res.data.code==200 & res.data.data!=null){	
				
				this.confirmFlag = false;
				this.$message.success("命令已下发成功，稍后可刷新页面查看设备状态是否改变。");
				
			}else if(res.data.code==10008){
				this.delCookie('username');
					this.$router.push('/login/');
					this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);  
			}else{
				//console.log(res.data.msg);
				this.confirmFlag = false;
				this.$message.error(res.data.msg);
			}
		});
	}
	
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/comss/controlDevice.vue